import React from 'react';

const DefaultCornerSVG: React.FC = () => (
    <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0C3 1 3 6.5 3 13H16C16 12.5 15.3539 10.1387 13 7C10.6461 3.86135 5.5 0.5 0 0Z" fill="white" />
    </svg>
);

export default DefaultCornerSVG;
